module.exports = __webpack_public_path__ + "img/yggx.f7530f59.svg";